module.exports = __webpack_public_path__ + "static/img/d-3.26b02a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/d-3.png
// module id = P9a3
// module chunks = 1